import CircularProgress from "@mui/material/CircularProgress";
import Button from "components/button/Button";
import MyButton from "components/MyButton/index";
import React from "react";
import { Body, Wrapper } from "./Theme";

export const Footer = ({ type, buttons, Wrapperstyle }) => {
  const renderButtons = () => {
    switch (type) {
      case "My template":
        return buttons?.map((item,index) => (
          <Button
            key={index}
            type={item?.type}
            variant={item?.variant}
            size="md"
            onClick={item?.action}
            disabled={item?.isDisabled}
            style={{
              marginRight: item?.marginRight || 20,
              width: item?.width,
            }}
          >
            {
              item?.loading ? (
                <div className="d-flex justify-content-center w-100">
                  <CircularProgress
                    size={22}
                    style={{
                      color:
                        item?.type === "primary"
                          ? "#ffffff"
                          : "var(--Blues-Blue-Main, #2555EF)",
                    }}
                  />
                </div>
              ) : (
                item?.name
              )
            }
          </Button>
        ));

      default:
        break;
    }
  };
  return (
    <Wrapper style={Wrapperstyle}>
      <Body>{renderButtons()}</Body>
    </Wrapper>
  );
};
